import { render } from "./AuditionPrep.vue?vue&type=template&id=5b2fbcca&scoped=true"
import script from "./AuditionPrep.vue?vue&type=script&lang=js"
export * from "./AuditionPrep.vue?vue&type=script&lang=js"

import "./AuditionPrep.vue?vue&type=style&index=0&id=5b2fbcca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2fbcca"]])

export default __exports__